import { Injectable } from '@angular/core';
import * as olProj from 'ol/proj';
import * as internal from 'events';
import { cloneDeep, sortedLastIndex } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import Geometry from 'ol/geom/Geometry';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { MenuManagementService } from '../menu/services/menu-management.service';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { AirSpaceBoundaryModel } from '../models/air-space-boundary';
import { AndFilter } from '../models/AndFilter';
import { LatLonDMS } from '../models/coord-dms';
import { CoordinatePoint, CoordinatePointModel } from '../models/coordinate-point';
import { FeatureType } from '../models/EnumTypes';
import { FilterModel } from '../models/filter';
import { OrFilter } from '../models/OrFilter';
import { ProcedureModel } from '../models/procedure';
import { SearchItem } from '../models/searchItem';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { CoordinatePointsFilterService } from './coordinate-points-filter.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ModalControlService } from './modal-control.service';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { SearchService } from './search.service';
import { ToolsControlService } from './tools-control.service';
import { UiBlockService } from './ui-block.service';
import { UtilsService } from './utils.service';
import Point from 'ol/geom/Point';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import { MapService } from './map.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CoordinatePointsService {
  public active: boolean;
  public selectedCoordinatePoint: CoordinatePointModel;
  public selectedCoordinatePointUserDefinedStatus:boolean = false;
  public azimuthAndDistance: boolean = false;
  public fullScreenMode:boolean = false;
  public editMode:boolean = false;
  maxAltitudeValid : boolean = true;
  minAltitudeValid : boolean = true;
  azimuthValid : boolean = true;
  distanceValid : boolean = true;
  latitudeValid : boolean = true;
  lat_degreesValid : boolean = true;
  lat_minutesValid : boolean = true;
  lat_secondsValid : boolean = true;
  longitudeValid : boolean = true;
  lon_degreesValid : boolean = true;
  lon_minutesValid : boolean = true;
  lon_secondsValid : boolean = true;


  azimuth:number = 0.0;
  distance:number = 0.0;

  constructor(private projectService : ProjectService,
    private pointsController : PointsService,
    private modalService : ModalControlService,
    private modalConfirmation : ModalConfirmationService,
    private searchService : SearchService,
    private popupService : BsModalService,
    private utilsService : UtilsService,
    private toolsService : ToolsControlService,
    private coordinatePointsFilterService: CoordinatePointsFilterService,
    private uiBlock: UiBlockService,
    private http : HttpClient,
    private endpointService: EndpointsService,
    private mapService: MapService,

    ) {
      let deleteCoordinatePoint : SearchItem = new SearchItem();
      deleteCoordinatePoint.name = "Delete Coordinate Point";
      deleteCoordinatePoint.action = () => this.deleteCP();
     }


    setValidationValid(value : boolean) : void {
    this.maxAltitudeValid = value;
    this.minAltitudeValid = value;
    this.azimuthValid = value;
    this.distanceValid = value;
    this.lat_degreesValid = value;
    this.lat_minutesValid = value;
    this.lat_secondsValid = value;
    this.lon_degreesValid = value;
    this.lon_minutesValid = value;
    this.lon_secondsValid = value;
    this.latitudeValid = value;
    this.longitudeValid = value;
  }

  createCP(coordinatePoint?:CoordinatePointModel){
    this.openFooter();
    if (this.projectService.projectEditable()){
      this.setValidationValid(true);
      if(typeof coordinatePoint == 'undefined')
        this.selectedCoordinatePoint = new CoordinatePointModel();
      else
        this.initializeSelectedCP(coordinatePoint);
      this.editMode = false;
    }
  }

  // createCPFromNavaid(){
  //   if (this.projectService.projectEditable()){
  //     if(this.pointsController.getSelectedFeatures().length == 1 && this.pointsController.getSelectedFeatures()[0].getProperties().featureType != 0){
  //       this.modalService.showMesssageModal("Warning", "Please select only 1 NavAid.");
  //       return;
  //     }
  //     var lat = this.pointsController.selectedFeatures[0].get("latitude");
  //     var lon = this.pointsController.selectedFeatures[0].get("longitude");
  //     this.active = true;
  //     this.selectedCoordinatePoint = new CoordinatePointModel();
  //     this.selectedCoordinatePoint.latitude = lat;
  //     this.selectedCoordinatePoint.longitude = lon;
  //     this.selectedCoordinatePoint.latLonDms.fromLat(lat);
  //     this.selectedCoordinatePoint.latLonDms.fromLon(lon);
  //     this.menuService.toogleMenu();
  //     this.toolsService.navigationOnTop = true;
  //   }
  // }
  openFooter(){
    this.active = true;
  }

  closeFooter(){
    this.active = false;
    this.azimuthAndDistance = false;
  }
  initializeSelectedCP(coordinatePoint: CoordinatePointModel){
    this.selectedCoordinatePoint =  cloneDeep(coordinatePoint);
    this.selectedCoordinatePointUserDefinedStatus = this.selectedCoordinatePoint.userdefined;
    this.selectedCoordinatePoint.latLonDms = new LatLonDMS() ;
    this.selectedCoordinatePoint.latLonDms.fromLat(this.selectedCoordinatePoint.latitude);
    this.selectedCoordinatePoint.latLonDms.fromLon(this.selectedCoordinatePoint.longitude);
    this.openFooter();
  }
  setInitialCreateCPFromCoords(latitude:number,longitude:number){
    this.selectedCoordinatePoint = new CoordinatePointModel();
    this.selectedCoordinatePoint.latitude = latitude;
    this.selectedCoordinatePoint.longitude = longitude;
    this.selectedCoordinatePoint.latLonDms.fromLat(latitude);
    this.selectedCoordinatePoint.latLonDms.fromLon(longitude);
    this.openFooter();
    //this.menuService.toogleMenu();

    this.setValidationValid(true);
  }
  setCPFromAzimuthAndDistance(azimuth: number = 0.0 ,distance:number = 0.0){
    this.azimuthAndDistance = true;
    this.editMode = false;
    this.distance = distance;
    this.azimuth = azimuth;
  }
  setCPFromNavaid(){
    this.azimuthAndDistance = false;
    this.editMode = false;
  }
  setEditCPInitialState(coordinatePoint: CoordinatePointModel){
    this.initializeSelectedCP(coordinatePoint)
    this.openFooter();
    this.editMode = true;
    this.setValidationValid(true);
  }

  
  editCP(){
    if (!this.projectService.projectEditable()){
      return;
    }
    let features : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.CoordinatePoint);
    if(features.length > 1){
      const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
        backdrop: 'static' // Prevent closing on backdrop click
      });
      bsModalRef.content.entity = "Coordenate Points";
      bsModalRef.content.type = "Edit";
      bsModalRef.content.selectAllActive = false;
      bsModalRef.content.data = features;
      bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Coordenate Points");
      bsModalRef.content.onClose.subscribe(result => {
        if(result.length == 1){
          let feature : any = this.pointsController.getSelectedFeatures().find(feat => feat.get("id") == result[0].id && feat.get("featureType") == 1);
          this.selectedCoordinatePoint =  cloneDeep(this.pointsController.transformFeatureInCoordinatePoint(feature));
          this.selectedCoordinatePointUserDefinedStatus = this.selectedCoordinatePoint.userdefined;
          this.selectedCoordinatePoint.latLonDms.fromLat(this.selectedCoordinatePoint.latitude);
          this.selectedCoordinatePoint.latLonDms.fromLon(this.selectedCoordinatePoint.longitude);
          this.active = !this.active;
          //this.menuService.toogleMenu();
          this.toolsService.navigationOnTop = true;
        }
        else{
          this.modalService.showMesssageModal("Warning", "Select at least one Coordinate Point to edit.");
        }
      });
    }else if (features.length == 1){
      this.selectedCoordinatePoint =  cloneDeep(this.pointsController.transformFeatureInCoordinatePoint(features[0]));
      this.selectedCoordinatePointUserDefinedStatus = this.selectedCoordinatePoint.userdefined;
      this.selectedCoordinatePoint.latLonDms.fromLat(this.selectedCoordinatePoint.latitude);
      this.selectedCoordinatePoint.latLonDms.fromLon(this.selectedCoordinatePoint.longitude);
      this.active = true;
      this.toolsService.navigationOnTop = true;
    }else{
      this.modalService.showMesssageModal("Warning", "Select at least 1 Coordinate Point to edit.");
    }
    this.editMode = true;
    this.setValidationValid(true);
  }

  async deleteCP(){
    if (!this.projectService.projectEditable()){
      return;
    }
    try{
      var coordinatePoints =  this.pointsController.getSelectedCoordinatePoints();
    }catch(error){
     this.modalService.showMesssageModal("Warning","Select at least one Coordinate Point to edit.")
   }
   if(coordinatePoints == null){
     return;
   }
   if(coordinatePoints.length >= 1){
     const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
       backdrop: 'static' // Prevent closing on backdrop click
     });
     bsModalRef.content.entity = "Coordenate Points";
     bsModalRef.content.type = "Delete";
     bsModalRef.content.selectAllActive = true;
     bsModalRef.content.dataSource = DynamicTable.transformCoordinatePointsInDataSource(coordinatePoints);
     bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Coordenate Points");
      bsModalRef.content.onClose.subscribe((results: any[] )=> {
      if(results.length>0){
        let coordinatePointsToDelete:CoordinatePointModel[] = [];
        results.forEach((result) =>{
        coordinatePointsToDelete.push(...coordinatePoints.filter(coordinatePoint => coordinatePoint.coordpointid == result.Id));
        })
        const procedures: ProcedureModel[] = this.pointsController.getAllProceduresModelsFromLayers();
        for (const procedure of procedures){
          const coordPointsIds: number[] = this.pointsController.getCoordinatePointsFromLegs(procedure).map(c => c.id);
          for (const coordPoint of coordinatePointsToDelete){
            if (coordPointsIds.includes(coordPoint.id)){
              this.modalService.showMesssageModal("Deletion Error", `It is not possible to delete the Coordinate Point ${coordPoint.coordpointid}
              because it is being used in Procedure ${procedure.procedureid}.`);
              return;
            }
          }
        }
        const airspaceBoundaries: AirSpaceBoundaryModel[] = this.pointsController.getAllAirSpaceBoundaryModelsFromLayers();
        for (const airspaceBoundary of airspaceBoundaries){
          const coordPointsIds: number[] = airspaceBoundary.airSpaceBoundaryCoordinatePoints.map(c => c.coordPoint.id);
          for (const coordPoint of coordinatePointsToDelete){
            if (coordPointsIds.includes(coordPoint.id)){
              this.modalService.showMesssageModal("Deletion Error", `It is not possible to delete the Coordinate Point ${coordPoint.coordpointid}
              because it is being used in Air space Boundary ${airspaceBoundary.uniqueid}.`);
              return;
            }
          }
        }
        this.modalConfirmation.showMesssageConfirmationModal("Delete Coordenate Points", "Do you want to delete the selected Coordenate Points?",
        "Yes", "No", () => this.pointsController.deleteCoordinatePoints(coordinatePointsToDelete));
      }
    });
    }
    //this.menuService.toogleMenu();
  }

  getCoordinatePointPayload(coordPoint: CoordinatePointModel) : CoordinatePoint {
    let coordinatePointPayload:CoordinatePoint = <CoordinatePoint><unknown>{
      "id":coordPoint.id,
      "coordpointid":coordPoint.coordpointid,
      "name":coordPoint.name,
      "type":coordPoint.type,
      "latitude":coordPoint.latitude,
      "longitude":coordPoint.longitude,
      "minaltitude":coordPoint.minaltitude,
      "maxaltitude":coordPoint.maxaltitude,
      "nominalaltitude":coordPoint.nominalaltitude,
      "notupdate":coordPoint.notupdate,
      "updated":coordPoint.updated,
      "userdefined":coordPoint.userdefined,
      "projectId": coordPoint.projectId,
      "configId": coordPoint.configId
    }
    return coordinatePointPayload;
  }
  
  async getCoordinaPointsDuplicates(id: string): Promise<boolean> {
    return await this.http
      .post<boolean>(
        this.endpointService.endpointGetDuplicateCoordindatePointsByIds,
        id,
        this.endpointService.httpOptions
      )
      .toPromise();
  }
}

